import { useEffect, useRef } from 'react';

const useHomeStatsEffects = ({
  resolvedUid,
  fetchUserStats,
  fetchGamification,
  fetchForumUnread,
  fetchChatUnread,
  resetLeaderboardRuntimeCache,
  triviaMode,
  location,
}) => {
  useEffect(() => {
    const cur = String(resolvedUid || '');
    try {
      const last = localStorage.getItem('lastUid') || '';
      if (cur && last !== cur) {
        localStorage.setItem('lastUid', cur);
        try { window.__lbPrefetchDone = false; } catch {}
        try { resetLeaderboardRuntimeCache(); } catch {}

        (async () => {
          try { await fetchUserStats(true); } catch {}
          try { await fetchGamification(); } catch {}
        })();
      }
    } catch {}
  }, [resolvedUid, fetchUserStats, fetchGamification, resetLeaderboardRuntimeCache]);

  const statsPollRef = useRef(false);

  useEffect(() => {
    if (statsPollRef.current) return;
    if (!resolvedUid) return;

    statsPollRef.current = true;
    let stopped = false;

    fetchUserStats(true);

    const interval = setInterval(() => {
      if (!stopped) {
        fetchUserStats();
      }
    }, 3 * 60 * 1000);

    return () => {
      stopped = true;
      clearInterval(interval);
      statsPollRef.current = false;
    };
  }, [fetchUserStats, resolvedUid]);

  useEffect(() => {
    if (triviaMode === 'played') {
      try { localStorage.removeItem('userStats:cache'); } catch {}
      try { localStorage.removeItem('gami:cache'); } catch {}

      (async () => {
        try { await fetchUserStats(); } catch {}
        try { await fetchGamification(); } catch {}
      })();
    }
  }, [triviaMode, fetchUserStats, fetchGamification]);

  useEffect(() => {
    const onVis = async () => {
      if (document.visibilityState !== 'visible') return;

      try { await fetchForumUnread(); } catch {}
      try { await fetchChatUnread(); } catch {}

      if (process.env.NODE_ENV === 'production') {
        try { await fetchUserStats(true); } catch {}
        try { await fetchGamification(); } catch {}
      }
    };

    document.addEventListener('visibilitychange', onVis);
    return () => document.removeEventListener('visibilitychange', onVis);
  }, [fetchUserStats, fetchGamification, fetchForumUnread, fetchChatUnread]);

  useEffect(() => {
    if (!resolvedUid) return;
    if (location?.pathname !== '/') return;

    (async () => {
      try { await fetchUserStats(true); } catch {}
      try { await fetchGamification(); } catch {}
    })();
  }, [resolvedUid, location?.pathname, fetchUserStats, fetchGamification]);
};

export default useHomeStatsEffects;
